import * as React from "react"
import { Info } from "lucide-react"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip"

/**
 * InfoTooltip - Composant d'infobulle contextuelle
 * Affiche une icône (?) ou ⓘ avec une explication au survol
 */
const InfoTooltip = React.forwardRef(({ 
  content, 
  children,
  className = "",
  iconClassName = "",
  side = "top",
  delayDuration = 300,
  maxWidth = "280px",
  asChild = false
}, ref) => {
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip>
        <TooltipTrigger asChild={asChild} ref={ref}>
          {children || (
            <span className={`inline-flex items-center justify-center cursor-help ${className}`}>
              <Info className={`w-3.5 h-3.5 text-muted-foreground hover:text-foreground transition-colors ${iconClassName}`} />
            </span>
          )}
        </TooltipTrigger>
        <TooltipContent 
          side={side} 
          className="bg-popover text-popover-foreground border border-border shadow-lg p-3 text-sm leading-relaxed"
          style={{ maxWidth }}
        >
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
})

InfoTooltip.displayName = "InfoTooltip"

export { InfoTooltip }
